import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import translationPL from './locales/pl/translation.json';
import translationEN from './locales/en/translation.json';
import translationDE from './locales/de/translation.json';

const resources = {
  pl: {
    translation: translationPL
  },
  en: {
    translation: translationEN
  },
  de: {
    translation: translationDE
  }
};

i18n.use(initReactI18next).init({
  resources,
  lng: 'pl',
  interpolation: {
    escapeValue: false
  }
});

export default i18n;
